import { createContext, useContext } from 'react'

import { Cue } from '~shared/rundown/cue'

export const CueContext = createContext<Cue['id'] | null>(null)

CueContext.displayName = 'CueContext'

export const useCueId = () => {
  const cueId = useContext(CueContext)

  if (!cueId) {
    throw new Error('useCueId must be used within a <Cue>')
  }

  return cueId
}
